  <template>
  <v-layout>
    <v-flex xs12 md8 offset-md2>
  <v-toolbar flat color="transparent" dense class="header-desktop" justify-center>
    <v-layout class="header-content" align-center>
      <v-toolbar-title class="header-left hidden-xs-only">

        <div v-if="this.showLogo" class="logo" router to="/" @click="gotoMainPage">
                <v-layout v-if="this.$subdomainPartner === '5a4fa82c8e4b74e028665d04'">
          <img :src="'https://storage.googleapis.com/onechart-assets/logos/header/5a4fa82c8e4b74e028665d04.png'" height="40" alt="" style="margin-right:10px;">
          <img style="border-left: 1px solid white; padding-left:10px;margin-top:13px;" :src="'https://storage.googleapis.com/onechart-assets/logos/header/default_white.png'" height="14" alt="">
        </v-layout>
          <img v-else-if="this.$subdomainPartner === '5a3f56ec92808ba8d3d5a391'"  :src="this.showLogo" height="20" alt=""> 
          <img v-else-if="this.$subdomainPartner != 'default'" style="margin-top:3px" :src="this.showLogo" height="40" alt="">
          <img v-if="this.$subdomainPartner === 'default'" style="margin-top:3px" :src="this.showLogo" height="20" alt="">
        </div>
        

        <div v-else class="logo" router to="/" @click="gotoMainPage">
          <!-- <i class="material-icons small hidden-xs-only" style="padding:5px; margin-right:20px; backgroundColor:#4485ed;border-radius:50%; color:#E6E6E8">folder</i> -->
          <div class="logo-title">OneChart</div>
        </div>

      </v-toolbar-title>
      
      <v-spacer></v-spacer>

      <slot name="center"></slot>

      <v-toolbar-title v-if="this.showLogo" class="hidden-sm-and-up" @click="gotoMainPage">
        <v-layout v-if="this.$subdomainPartner === '5a4fa82c8e4b74e028665d04'">
          <img :src="'https://storage.googleapis.com/onechart-assets/logos/header/5a4fa82c8e4b74e028665d04_mobile.png'" height="14" alt="" style="margin-right:10px;">
          <img style="border-left: 1px solid white; padding-left:10px;" :src="'https://storage.googleapis.com/onechart-assets/logos/header/default_white.png'" height="14" alt="">
        </v-layout>
        <img v-else-if="this.$subdomainPartner === '5a3f56ec92808ba8d3d5a391'"  :src="this.showLogo" height="20" alt=""> 
        <img v-else-if="this.$subdomainPartner != 'default'"  :src="this.showLogo" height="40" alt="">          
        <img v-if="this.$subdomainPartner === 'default'" style="margin-top:3px" :src="this.showLogo" height="20" alt="">

      </v-toolbar-title>

      <v-toolbar-title v-else class="hidden-sm-and-up">
        <div class="logo" router to="/" @click="gotoMainPage">
          <div class="logo-title">OneChart</div>
        </div>

      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- right  -->
      <div class="header-right" style="position:absolute; right:0px;">
        <v-menu v-if="user" bottom offset-y class="main-menu-label">
          <v-layout style="margin-right:10px;" row align-center justify-end
              class="profile-content" 
              slot="activator">
            <div class="hidden-xs-only username mr-1">{{ username }}</div>
            <div><v-badge v-if="showAlert && this.$vuetify.breakpoint.smAndDown"
        color="yellow"
        left
        overlap
      >
        <v-icon
          slot="badge"
          dark
          small
        >priority_high</v-icon>
        <v-icon
          color="contrast"
          medium
        >
          account_circle
        </v-icon>
      </v-badge>
      <v-badge v-else-if="showAlert"
        color="yellow"
        right
        overlap
      >
        <v-icon
          slot="badge"
          dark
          small
        >priority_high</v-icon>
        <v-icon
          color="contrast"
          medium
        >
          account_circle
        </v-icon>
      </v-badge><v-icon v-else
          color="contrast"
          medium
        >
          account_circle
        </v-icon></div>
          </v-layout>
          <v-list dense>
            <v-list-tile 
            v-for="option in menuItems" :key="option.label"
            @click="option.action()">
              <v-list-tile-title class="main-menu-label">
                <v-layout row align-center>
                  <icon class="menu-icon" v-if="option.icon" 
                    :icon="option.icon" :size="20"></icon>
                  {{ $t(option.label) }}
                </v-layout>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!-- <v-layout row align-center justify-end class="main-menu-label chat" @click="navToSupport">
          <div class="mr-2" v-t="'links.support.label'"></div>
          <icon icon="chat" :size="20"></icon>
        </v-layout> -->
      </div>
    </v-layout>
  </v-toolbar>
    </v-flex>
  </v-layout>
</template>

<style lang="scss" scoped>
$primaryColor: #1565c0;
$dark-charcoal: #222;

.logo {
  display: flex;
  font-size: 18px;
  align-items: center;
  color: #4485ed;
  text-transform: uppercase;
  line-height: 62px;
  letter-spacing: 7px;
  font-weight: 300;
  cursor: pointer;
  .logo-icon {
    margin-right: 5px;
  }
}


.header-right {
  display: inline-flex;
}
.header-right .chat {
  margin-left: 36px;
  cursor: pointer;
}
.main-menu-label {
        font-size: 16px;
        line-height: 24px;
        color:$dark-charcoal;
        font-weight: 400;
      }

.menu-icon {
  font-size: 20px;
  font-weight: 400;
  margin-right: 8px;
}
</style>

<script>
import each from 'lodash/each'
import isNil from 'lodash/isNil'
import Avatar from '@/core/components/Avatar'
import Icon from '@/core/components/Icon'

export default {
  name: 'UiHeader',
  components: {
    Avatar,
    Icon
  },
  props: {
    user: {
      type: Object
    },
    userImageUrl: {
      type: String
    },
    mainMenu: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    showAlert() {
      if (this.user.needsPasswordChange) {
        return true
      }
      return false
    },
    username() {
      return this.user.firstName + ' ' + this.user.lastName
    },
    showLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/header/' + this.$subdomainPartner + '.png'
    },
    menuItems() {
      let items = []
      each(this.mainMenu, item => {
        if (isNil(item.condition) || item.condition) {
          items.push(item)
        }
      })
      return items
    }
  },
  methods: {
    navToSupport() {
      location.href = 'https://www.zendesk.com/'
    },
    gotoMainPage() {
      this.$router.push('/')
    }
  }
}
</script>

<i18n src='./DesktopHeader.locale.json'></i18n>


// WEBPACK FOOTER //
// src/core/components/DesktopHeader.vue